module.exports = "../../../../platform/assets/pageMainIcon/danjuweihulei3.svg";